import React, { Component } from "react";
import { Tabs } from "@adrianoferreira/wp-react-admin";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import TableSelection from "./../DisplayCustomTable/TableSelection";
import DefaultFieldsFilter from "./DefaultFieldsFilter";

export const CreateCustomTable = (props) => {

	return(
		<div id="poststuff" className="display-data-box">
			<div id="slugdiv" className="postbox">
				<h2 className="hndle ui-sortable-handle"><span>Create Entries on Custom Tables</span></h2>
				<div className="inside" style={{display: 'block'}}>

					<p>This action should be used whenever you want to insert data into any custom database table.</p>

						{props.endpoint.createCustomTable && props.endpoint.createCustomTable.map(
							(el, index) =>

									<FieldGroupContext.Provider key={index} value={{
										action: 'createCustomTable',
										currentItem: index,
										endpointId: props.id,
										endpoint: props.endpoint
									}}>

									<Tabs tabs={[
										{
											name:    'tableSelection',
											title:   'Table Selection',
											content: <TableSelection group={'tableSelection'} key={index + '-tableSelection'}/>
										},
										{
											name:    'defaultFields',
											title:   'Columns to Populate',
											content: <DefaultFieldsFilter group={'defaultFields'} key={index + '-defaultFields'}/>
										},
									]} />

								</FieldGroupContext.Provider>
						)}

				</div>
			</div>
		</div>
	)
};
